import { createFileRoute } from '@tanstack/react-router';
import { InstructorCourseEditorPage } from '@pages/instructor';

/**
 * Course Editor Page
 *
 * Route: /:locale/instructor/courses/:courseId
 * Edit and manage a specific course
 */
export const Route = createFileRoute('/$locale/_authenticated/instructor/courses/$courseId')({
  component: CourseEditor,
});

function CourseEditor() {
  const { locale, courseId } = Route.useParams();
  return <InstructorCourseEditorPage locale={locale} courseId={courseId} />;
}
